export class HomeAccountDetails {
  followerCount: string;
  myToken: string;
  profileCompleted: string;
  upcomingConferenceCount: string;
  myConnections: string;
  mySubscriptions?: string;
}



// WEBPACK FOOTER //
// ./src/app/feature/main/roles-shared/models/homeModel.ts